export const NO_SCROLL = 'no-scroll';
export const SCROLLABLE = 'scrollable';
export const ACTIVE = 'is-active';
export const ROLLED = 'is-rolled';
export const OPENED = 'is-open';
export const DROPDOWN_OPEN = 'is-dropdown-open';
export const HIDDEN = 'is-hidden';
export const STICKY = 'is-sticky';
export const ENTER = 'enter';
export const LEAVE = 'leave';
export const OUT = 'out';
